import type { ReactNode } from 'react';
import { type DehydratedState, Hydrate, type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import prepareQueryClient, { type RequiredQueryClientData } from './prepareQueryClient';

export default function QueryClientInitializer({
    children,
    queryClient,
    dehydratedState,
    data
}: {
    children: ReactNode;
    queryClient: QueryClient;
    dehydratedState: DehydratedState;
    data: RequiredQueryClientData;
}) {
    // if the server didn't provide a dehydrated queryClient state we should resort to preparing the queryClient with data from stateData, so that RequiredQueryClientData will still be available. This is for cases where SSR might be disabled.
    if (!dehydratedState) {
        const preparedQueryClient = prepareQueryClient(queryClient, data);

        return <QueryClientProvider client={preparedQueryClient}>{children}</QueryClientProvider>;
    }

    // if the server provided a dehydrated client, we should hydrate our queryClient with the dehydrated state.
    return (
        <QueryClientProvider client={queryClient}>
            <Hydrate state={dehydratedState}>{children}</Hydrate>
        </QueryClientProvider>
    );
}
